<template>
  <div id="app">
    <Header/>
    <RouterView/>
    <Footer/>
    <NotificationBlock/>
  </div>
</template>

<script>

import VueRouter from 'vue-router'

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import MainPageSections from './components/MainPageSections.vue'
import NotificationBlock from './components/NotificationBlock.vue'

import Solutions from './components/Solutions.vue'
import Faq from './components/Faq.vue'
import Thanks from './components/Thanks.vue'

const router = new VueRouter({
  mode: 'history',
  routes: [
    { name: 'main', path: '/', component: MainPageSections },
    { name: 'solutions', path: '/solutions', component: Solutions },
    { name: 'faq', path: '/faq', component: Faq },
    { name: 'thanks', path: '/thanks', component: Thanks },
  ]
})

export default {
  name: 'app',
  components: {
    Header,
    Footer,
    NotificationBlock,
  },
  router
}
</script>
